import { Link } from "@/i18n/routing";
import { CurrencySymbol } from "@repo/components";
import { formProductOptionsString } from "@repo/lib/helpers";
import { Media } from "@repo/ui";
import { Fragment } from "react";
const CartSummary = props => {
  const {
    products
  } = props;
  return <>
      {products?.map(item => {
      const productOptions = formProductOptionsString(item);
      return <Fragment key={item?.id}>
            <div className="border-supportiveDarkGray mb-6 flex items-center border-t px-3 py-4">
              <Link href={item?.slug} className="flex w-4/5 items-center space-x-5 rtl:space-x-reverse">
                <Media src={item?.image?.imageURI} alt={item?.name} width={72} height={72} className="hover:opacity-70" />
                <div>
                  <p className="text-supportiveBlack mb-1 line-clamp-2 text-sm uppercase md:text-base">
                    {item?.name}
                  </p>
                  {productOptions && <span className="text-supportiveGray4 text-sm font-medium">
                      {productOptions}
                    </span>}
                  <p className="text-sm font-semibold md:text-base md:font-semibold">
                    <CurrencySymbol variant="smallSpecial" value={item?.formattedSalePrice} />
                  </p>
                </div>
              </Link>
              <div className="text-supportiveBlack w-1/5 text-end text-sm">
                x {item?.quantity}
              </div>
            </div>
          </Fragment>;
    })}
    </>;
};
export default CartSummary;